const mediaItem = {
    props: {
        card: {
            type: Object,
            default() {
                return null;
            },
        }
    },
    template: 
    `<div class="b-media-item">
        <template v-if="card.type==='image'">
            <div @click="clicked" class="b-media-item--image" :style="{ backgroundImage: 'url(' + cardBg + ')' }">
                <div v-if="card.title && card.title !==''" class="b-media-item__title" v-html="card.title"></div>
            </div>
        </template>
        <template v-if="card.type==='file'">
            <b-media-item--file :card="card"></b-media-item--file>
        </template>
        <template v-if="card.type==='video'">
            <div @click="clicked" class="b-media-item--video" :style="{ backgroundImage: 'url(' + cardBg + ')' }">
                <span class="btn--play btn--play--large btn--play--white"><span>btn--play</span></span>
            </div>
        </template>
    </div>`,
    computed: {
        cardBg() {
            if (this.card !== null && this.card.thumb && this.card.thumb !== "") {
                return this.card.thumb;
            }
            return "";
        }
    },
    methods:{
        clicked(e){
            this.$emit("clicked", e, this.card)
        }
    }
};
